import { getFilterCss, mergeEditState } from '@ciancio/shared';

export const ImageBox = ({ image, onEdit, onRemove }) => {
  const editState = mergeEditState(image.editState);
  const preview = image.editedUrl || image.previewUrl;

  return (
    <div className="image-box col-6 col-sm-4 col-md-3 col-xl-2">
      <button className="image-edit-trigger" type="button" onClick={() => onEdit(image.id)} aria-label={`Edit ${image.file.name}`}>
        <span className="image-preview-frame">
          <img
            src={preview}
            alt={image.file.name}
            className="image-preview"
            style={{
              filter: image.editedUrl ? 'none' : getFilterCss(editState),
              objectPosition: `${editState.crop.x}% ${editState.crop.y}%`,
            }}
          />
        </span>
      </button>
      <button className="btn btn-danger btn-sm image-delete-button" type="button" onClick={() => onRemove(image.id)} aria-label={`Delete ${image.file.name}`}>
        <i className="bi bi-trash3" />
      </button>
    </div>
  );
}
